function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.09,146.22S347,36.68,252,25.05C168.15,14.8,90.31,54.89,79.48,141.55c-3.87,30.87-10.74,65-23,93.2-13.69,31.59-37,57.89-19.15,118.62s93.46,115.56,148.4,115.43,106.55-50.06,149.12-95.48S513.07,285.22,423.09,146.22Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.09,146.22S347,36.68,252,25.05C168.15,14.8,90.31,54.89,79.48,141.55c-3.87,30.87-10.74,65-23,93.2-13.69,31.59-37,57.89-19.15,118.62s93.46,115.56,148.4,115.43,106.55-50.06,149.12-95.48S513.07,285.22,423.09,146.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--walkie-talkie--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.48,114.8a4.48,4.48,0,1,1-4.47-4.26A4.36,4.36,0,0,1,140.48,114.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.43,29.34l-6.75,91s-9,7.08-11,16.14-.4,49.61.39,57.87,1.18,35,1.58,52,1.18,42.12,4.33,46.45,11,9.06,22,9.85,23.55-1.72,36.93-3.3,31.58-9.3,32-18,5.52-73.24,5.91-79.53,3.54-12.6,3.15-21.66,0-40.95-1.57-48S143,119.92,143,119.92l.79-3.15-15.36-3.54L127,116.78s-23.78-2-34-.79L90.17,29.76A10.38,10.38,0,0,0,80,19.72h0A10.39,10.39,0,0,0,69.43,29.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.68,126.88s-19,1.1-24,4.68-6.33,8.25-6.88,14.58-1.65,41.56-1.37,46.24,1.92,11.56,1.92,19.81a117,117,0,0,0,.83,14.32l22.57,8.25s14.58-9.08,23.12-8.53,17.06,4.4,17.06,4.4l17.34-9.9s-.28-23.4.55-26.42,1.65-5.23,1.65-8.81,1.1-40.73,1.1-45.14-4.13-8.8-9.63-10.73S117.37,125.23,101.68,126.88Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,126.59A19.24,19.24,0,0,1,117,123.48c6.57.69,9,3.45,9,3.45S108.55,126.3,105.12,126.59Z",
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.83,141.87s-.24,28.79.72,33.58,9.36,14.16,17,16.31c0,0,2.63,1,4.31,0s8.4-4.07,15.12-3.59,8.87,2.4,10.07,2.16,8.64-4.56,13.19-10.56,4.56-14.15,4.8-16.31-.72-20.63-1-22.79-3.36-2.4-7.19-3.12-20.39-1.68-36-.72S83.79,140,82.83,141.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.68,185.53,131.77,195.6v7.92s.48,1.92,3.12,1.44,9.83-3.12,10.79-4.32,2.16-12,1.92-13.67A1.66,1.66,0,0,0,145.68,185.53Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.83,198.72s.72,5,.24,6.24-2.4,1.92-4.08,1.92-11.76-1.2-13-2.4-2.39-13.67-1.2-14.87S100.83,198.72,100.83,198.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,207.06s-1,12-.71,13a1.46,1.46,0,0,0,1.7,1.27,66.89,66.89,0,0,0,9.33,0c3.25-.42,5.51-1.41,5.66-2.69s0-12.16-.57-12.86-1.27-.85-3-1-11,.7-11.88,1.13A.9.9,0,0,0,108.33,207.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.26,214.13S89.38,212,87.12,211.87s-3.68.56-3.82,2.68.28,9.34.57,9.76,9.61,4,10.6,3.68,6.65-3.11,7.07-3.68.43-7.35.57-8.63A1.34,1.34,0,0,0,101.26,214.13Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.69,208.19S131,210.88,130,211.58s-.85,1.42-1,2.55.29,7.35.29,7.35,5.23,3.11,6.36,2.83,9.33-4,9.47-5.66.57-8.06.43-9.05S144.24,208.05,142.69,208.19Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.89,197.91a2.82,2.82,0,1,1-2.75-2.16A2.51,2.51,0,0,1,118.89,197.91Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.73,174.21l-37.35.89a3,3,0,0,1-3.08-3v-21.9a3,3,0,0,1,2.93-3l37.36-.89a3,3,0,0,1,3.07,3v21.9A3,3,0,0,1,133.73,174.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5,244.47a2,2,0,0,1-.19-4c.23,0,23.64-2.31,40-3.83a2,2,0,0,1,.37,4c-16.38,1.51-39.78,3.8-40,3.82Z",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.09,255.94a2,2,0,0,1-.14-4c.39,0,39.25-2.83,53-6.07a2,2,0,0,1,.92,3.89c-14,3.31-52,6-53.6,6.17Z",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.79,268.43a2,2,0,0,1-.19-4c17.11-1.67,51.07-5.39,57.14-7.54a2,2,0,0,1,1.33,3.77c-8,2.85-56,7.55-58.08,7.75Z",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.45,273.87c-17.34,2.53-43.14,4.88-44.45,5h-.19a2,2,0,0,1-.18-4c.39,0,39.32-3.59,53.82-6.59a2,2,0,1,1,.81,3.91c-1.64.34-3.56.69-5.69,1",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.69,288.82a2,2,0,0,1-.13-4c.3,0,29.75-2.06,39.89-4.78a2,2,0,1,1,1,3.86c-10.52,2.82-39.43,4.83-40.66,4.91Z",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.68,144.84s0-3.83.76-4.34,6.12.26,6.37,1.79,1,36.2,0,40-5.1,3.31-6.11,1.53",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,185.37s.25,7.39.51,12.74,2.29,20.14,1.78,28.81S58.81,285,58.81,285s.51,6.88,1.79,8.67",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7,287.91a28.1,28.1,0,0,0,.76,6c1.78,3.83,4.33,5.61,6.37,6.12",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.46,228.78c.09,15.49.34,40.86,1,55",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.4,129.54A45.63,45.63,0,0,0,135,122.15c-11.47-1.53-33.65-.76-45.88,1.53S67,129,62.89,135.66s-2.8,53.53-2,59.91,3.57,10.7,3.57,21.66c0,1.52,0,4,0,7.2",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.58,230.74s-.51,58.12-.51,61.44,3.31,7.13,9.94,7.9,27-1.27,40.53-3.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.08,171.91l33.28-1.25a3.62,3.62,0,0,0,3.49-3.48l.7-18.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,56.09l1.88-28.37s3.23-8.08,7.44-8",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.79,140s-.47-9.32,4.19-11.65S66.5,119,66.5,119l3.87-58.3",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.69,111.12s13.52-.93,20-3.73",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.76,115.78s13.51-.93,20-3.73",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.77,107.23s-15.61-29.48-44.22-33.81S370.33,91.63,366.86,97.7s-19.07-10.41-33.81-3.47-9.54,22.54-15.61,25.14S300.1,115,294,121.11,288,137.58,288,137.58H487.39s-4.34-19.07-16.48-26.88S457,118.51,445.77,107.23Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.22,49.44s-7.87-14.86-22.3-17-15.74,9.18-17.49,12.24-9.62-5.24-17.05-1.74-4.81,11.36-7.87,12.68-8.75-2.19-11.81.87-3.06,8.31-3.06,8.31H247.2s-2.18-9.62-8.3-13.56S231.9,55.13,226.22,49.44Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.71,273.21c0,49.67-25.12,69.49-56.11,69.49s-56.1-19.82-56.1-69.49,25.12-122.62,56.1-122.62S484.71,223.55,484.71,273.21Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.71,273.21c0,49.67-25.12,69.49-56.11,69.49s-56.1-19.82-56.1-69.49,25.12-122.62,56.1-122.62S484.71,223.55,484.71,273.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.5 454.94 434.61 454.94 429.81 283.23 430.31 289.71 460.34 253.44 429.78 282.31 428.7 243.7 441.64 228.51 428.55 238.32 428.04 220.01 427.06 255.08 412.17 245.51 426.95 259.23 421.5 454.94",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.2 313.51 399.14 295.95 425.2 319.75 425.2 313.51",
    style: {
      fill: "#bababa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232,285.43l-76.17,22.43S113.09,383,110.48,398.11,96.91,455,96.91,455H426.09s11-64.68,12-73.55,3.65-12.52,3.65-12.52-30.26-45.39-36.52-52.17-85-25.56-85-25.56-33.91-7.83-48.52-9.91S232,285.43,232,285.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,442l-17.07-36.45-36.37-17.39L348,390.79,364,455h62.08S427,449.72,428.28,442Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.68 248.91 249.24 273.43 276.89 294.03 291.35 318.99 302.98 294.82 315.5 280.74 319.15 236.39 247.68 248.91",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.24 273.43 258.6 280.41 286.26 261.32 282.32 246.54 274.22 244.26 247.68 248.91 249.24 273.43",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.18 306.02 283.09 320.57 293.31 338.26 294.77 454.94 328.99 454.94 305.4 343.56 303.35 334.43 311.79 305.23 286.91 306.58 272.86 291.86 266.18 306.02",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.31,
    y1: 338.26,
    x2: 303.35,
    y2: 334.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "283.09 320.57 286.91 306.58 310.42 304.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.51 261.04 226.81 284.39 263.33 324.04 281.59 290.13 243.51 261.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.14,291.86c-.93.82-1.57,12.58,1.18,13.76s63,12,65.9,11.11,3.71-8.75,1.35-9.93S341.29,289.11,338.14,291.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.56,169.82s.58,52.37,1.15,57.54,16.4,35.1,19,37.12,9.78,4.89,14.67,4.31,33.09-14.1,40.85-19.27,15.83-24.17,15.83-24.17,11.22-4.89,15-11.22,1.15-20.71.86-22.15l-.29-1.44s-1.72-15.25-3.74-19.85-28.77-21.58-48.62-27.62-38.55-2.59-45.45,7.48A66.45,66.45,0,0,0,234.56,169.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.8,193.69s3.42,4.8,12,5.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77,194.38s-7.19,4.79-9.93,5.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.87,192s-2.88-4.61-5.47-3.17-7.76,10.07-9.2,9.21-6.62-19.85-7.48-24.74,3.16-4.32,5.75-2S341.87,189.39,341.87,192Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.62,174.14,341.87,192s.86-25.32,0-37.69-17.55-31.65-26.76-37.4-34.52-10.36-43.72-7.19-25.9,9.2-27.62,15.24S236,151.12,236,151.12s19.56-8.63,31.93-4,46.61,22.15,48.34,23.3S326.62,174.14,326.62,174.14Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.05,162.34s-2.59,3.74,2,6.62a11.16,11.16,0,0,0,9.49.86s6.91-15.53,18.7-18.12S272,152,272,152s-10.93-8.63-21.58-8.06S225.07,157.45,223.05,162.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.05,162.34s15.54-18.7,34.24-15.53,36.25,31.36,46.32,33.95,23-6.62,23-6.62-30.78-27.91-59.84-31.93S223.92,157.45,223.05,162.34Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,193.7,255.75,209a7.31,7.31,0,0,0,5.38,8.63,15.6,15.6,0,0,0,4.5.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82,230.53a18.35,18.35,0,0,0,8.92,4.89A20.79,20.79,0,0,0,276,232",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,191.11c0,1.75-1,3.17-2.3,3.17s-2.3-1.42-2.3-3.17,1-3.16,2.3-3.16S251,189.37,251,191.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.51,189.39c0,1.75-1,3.16-2.3,3.16s-2.3-1.41-2.3-3.16,1-3.17,2.3-3.17S289.51,187.64,289.51,189.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.74,184.5c.57-.87,6.33-6.91,16.4-2.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.43,180.47s10.07-7.77,22.15,2.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,213.63a6.26,6.26,0,0,1,4.62-3.38c2.85-.36,9.25,3,9.78,3.38a2.44,2.44,0,0,0,3.2-.72c1.07-1.42,10.85-23.29,10.85-23.29a7.65,7.65,0,0,1,7.47,3.56l-10.32,28.45s1.43,5,.54,7.46-5.87,8.36-5.87,8.36Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.3,235.28S291.57,208.44,287.62,207s-10.45.56-11.86,4.8-.57,6.5-.57,6.5-7.06.56-9.89,3.67-1.13,7.91-1.13,7.91-1.5,1.13-3.43,5.51.61,6.92.61,6.92-3.67,2-4,5.65,1.13,5.93,2.83,8.76,13.56,33.61,16.67,37.28,16.94,18.37,16.94,18.37l9.61,13.27,27.12-28.25-10.74-13.27L326,250.53s2-17.23,1.69-19.21a98.17,98.17,0,0,1-.28-14.12c.28-6.22-3.11-9-6.78-5.37s-3.11,17.23-3.11,18.36S315.3,235.28,315.3,235.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.3,235.28s6.78,8.75,7.07,12.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.19,218.33s10.45,6.21,16.1,14.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.17,229.91a44.36,44.36,0,0,1,14.41,11.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35,242.34s9.89,6.5,12.71,11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.45,288.38s-30.91,34.28-29.78,34.56,27.24,41.43,27.24,41.43l35.31-48.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.91,364.37s6.49,14.41,9.6,16.95,54,59.05,57.15,61.66,40.17,10.43,48,6.78,14.61-38.61,14.61-48S443.31,371,441.74,368.9s-32.35-14.6-38.6-23.48c-18-25.58-42.92-29.35-42.92-29.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,401.83a40.44,40.44,0,0,1,2.14,7.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.61,359s16.95,21.61,24.85,39.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.13,370.48a58.65,58.65,0,0,0,4.89,5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.55,347.62s1.22,9.41,9.26,20",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.38,306s11,5.11,15.73,4.72,55.84-20.85,57.81-23.21-.79-7.07-5.11-7.47S149,302.08,149.38,306Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,354.6c6.26,19,15.22,48.22,17,64.28,2.75,25.17,2,35.39,2,35.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.54,336.3s1.22,3.43,3.11,9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.18,352.81l9-3.54,4.72,7.48s-16.51,47.58-19.27,49.15-5.89,2.76-9-1.57a10.66,10.66,0,0,1-1.57-9.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "244.65 402.74 276.78 398.77 272.13 378.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "271.36 367.82 195.53 379.42 201.72 408.05 237.58 403.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,435.86c.54,4,.9,7,.9,7.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.46,405s2,13.45,3.62,24.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.52,
    y1: 439.87,
    x2: 208.69,
    y2: 445.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.5,
    y1: 413.47,
    x2: 206.54,
    y2: 434.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-64"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 479.58,
    y1: 454.97,
    x2: 35.64,
    y2: 454.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityImg);
export default __webpack_public_path__ + "static/media/security_img.70f7d8b015814cdf5bf11a58c89bc90c.svg";
export { ForwardRef as ReactComponent };